<template>
  <div>
    <div class="card card-outline">
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-hover table-borderless">
            <thead>
            <tr>
              <th scope="col">Color</th>
              <th scope="col" class="text-poppins">HEX</th>
              <th scope="col" class="text-poppins">RGB</th>
              <th scope="col" class="text-poppins">HSL</th>
              <th scope="col" class="text-poppins">HSV</th>
              <th scope="col" class="text-poppins">CMYK</th>
              <th scope="col" class="text-poppins">Pantone (Or similar)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="gradient.color1">
              <th scope="row"><i class="material-icons" :style="{'color' : gradient.color1}">circle</i></th>
              <td v-text="gradient.color1"></td>
              <td>{{ hexToRgb() }}</td>
              <td>{{ hexToHsl() }}</td>
              <td>{{ hexToHsv() }}</td>
              <td>{{ hexToCmyk() }}</td>
              <td>{{ hexToPantone() }}</td>
            </tr>
            <tr v-if="gradient.color2">
              <th scope="row"><i class="material-icons" :style="{'color' : gradient.color2}">circle</i></th>
              <td v-text="gradient.color2"></td>
              <td>{{ hexToRgb2() }}</td>
              <td>{{ hexToHsl2() }}</td>
              <td>{{ hexToHsv2() }}</td>
              <td>{{ hexToCmyk2() }}</td>
              <td>{{ hexToPantone2() }}</td>
            </tr>
            <tr v-else>
              <td>Loading....</td>
            </tr>
            <tr v-if="gradient.color3">
              <th scope="row"><i class="material-icons" :style="{'color' : gradient.color3}">circle</i></th>
              <td v-text="gradient.color3"></td>
              <td>{{ hexToRgb3() }}</td>
              <td>{{ hexToHsl3() }}</td>
              <td>{{ hexToHsv3() }}</td>
              <td>{{ hexToCmyk3() }}</td>
              <td>{{ hexToPantone3() }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import simpleColorConverter from "simple-color-converter";

export default {
  props: [
    'gradient'
  ],
  methods: {
    // RGB CONVERT
    hexToRgb(colorRgb) {
      colorRgb = new simpleColorConverter({
        hex: this.gradient.color1,
        to: 'rgb',
      })
      return 'rgb ' + '(' + colorRgb.color.r + ", " + colorRgb.color.g + ", " + colorRgb.color.b + ')';
    },
    hexToRgb2(colorRgb2) {
      colorRgb2 = new simpleColorConverter({
        hex: this.gradient.color2,
        to: 'rgb',
      })
      return 'rgb ' + '(' + colorRgb2.color.r + ", " + colorRgb2.color.g + ", " + colorRgb2.color.b + ')';
    },
    hexToRgb3(colorRgb3) {
      colorRgb3 = new simpleColorConverter({
        hex: this.gradient.color3,
        to: 'rgb',
      })
      return 'rgb ' + '(' + colorRgb3.color.r + ", " + colorRgb3.color.g + ", " + colorRgb3.color.b + ')';
    },

    // HSL CONVERT
    hexToHsl(colorHsl) {
      colorHsl = new simpleColorConverter({
        hex: this.gradient.color1,
        to: 'hsl',
      })
      return 'hsl ' + colorHsl.color.h.toFixed(0) + '°' + ", " + colorHsl.color.s.toFixed(0) + '%' + ", " + colorHsl.color.l.toFixed(0) + '%';
    },
    hexToHsl2(colorHsl2) {
      colorHsl2 = new simpleColorConverter({
        hex: this.gradient.color2,
        to: 'hsl',
      })
      return 'hsl ' + colorHsl2.color.h.toFixed(0) + '°' + ", " + colorHsl2.color.s.toFixed(0) + '%' + ", " + colorHsl2.color.l.toFixed(0) + '%';
    },
    hexToHsl3(colorHsl3) {
      colorHsl3 = new simpleColorConverter({
        hex: this.gradient.color3,
        to: 'hsl',
      })
      return 'hsl ' + colorHsl3.color.h.toFixed(0) + '°' + ", " + colorHsl3.color.s.toFixed(0) + '%' + ", " + colorHsl3.color.l.toFixed(0) + '%';
    },

    // HSV CONVERT
    hexToHsv(colorHsv) {
      colorHsv = new simpleColorConverter({
        hex: this.gradient.color1,
        to: 'hsv',
      })
      return 'hsv ' + colorHsv.color.h.toFixed(0) + '°' + ", " + colorHsv.color.s.toFixed(0) + '%' + ", " + colorHsv.color.v.toFixed(0) + '%';
    },
    hexToHsv2(colorHsv2) {
      colorHsv2 = new simpleColorConverter({
        hex: this.gradient.color2,
        to: 'hsv',
      })
      return 'hsv ' + colorHsv2.color.h.toFixed(0) + '°' + ", " + colorHsv2.color.s.toFixed(0) + '%' + ", " + colorHsv2.color.v.toFixed(0) + '%';
    },
    hexToHsv3(colorHsv3) {
      colorHsv3 = new simpleColorConverter({
        hex: this.gradient.color3,
        to: 'hsv',
      })
      return 'hsv ' + colorHsv3.color.h.toFixed(0) + '°' + ", " + colorHsv3.color.s.toFixed(0) + '%' + ", " + colorHsv3.color.v.toFixed(0) + '%';
    },

    // CMYK CONVERT
    hexToCmyk(colorCmyk) {
      colorCmyk = new simpleColorConverter({
        hex: this.gradient.color1,
        to: 'cmyk',
      })
      return 'cmyk ' + colorCmyk.color.c + '%' + ", " + colorCmyk.color.m + '%' + ", " + colorCmyk.color.y + '%' + ", " + colorCmyk.color.k + '%';
    },
    hexToCmyk2(colorCmyk2) {
      colorCmyk2 = new simpleColorConverter({
        hex: this.gradient.color2,
        to: 'cmyk',
      })
      return 'cmyk ' + colorCmyk2.color.c + '%' + ", " + colorCmyk2.color.m + '%' + ", " + colorCmyk2.color.y + '%' + ", " + colorCmyk2.color.k + '%';
    },
    hexToCmyk3(colorCmyk3) {
      colorCmyk3 = new simpleColorConverter({
        hex: this.gradient.color3,
        to: 'cmyk',
      })
      return 'cmyk ' + colorCmyk3.color.c + '%' + ", " + colorCmyk3.color.m + '%' + ", " + colorCmyk3.color.y + '%' + ", " + colorCmyk3.color.k + '%';
    },

    // PANTONE CONVERT
    hexToPantone(colorPantone) {
      colorPantone = new simpleColorConverter({
        hex: this.gradient.color1,
        to: 'pantone',
      })
      return 'Pantone ' + colorPantone.color;
    },
    hexToPantone2(colorPantone2) {
      colorPantone2 = new simpleColorConverter({
        hex: this.gradient.color2,
        to: 'pantone',
      })
      return 'Pantone ' + colorPantone2.color;
    },
    hexToPantone3(colorPantone3) {
      colorPantone3 = new simpleColorConverter({
        hex: this.gradient.color3,
        to: 'pantone',
      })
      return 'Pantone ' + colorPantone3.color;
    }
  }
}
</script>